import {
  List,
  DatagridConfigurable,
  TopToolbar,
  FilterButton,
  SelectColumnsButton,
  SelectArrayInput,
} from 'react-admin';
import { columns } from './DataExportsColumns';
import { genericCSVExporter } from '@/util/genericCSVExporter';
import {
  renderExportColumns,
  renderGridColumns,
  renderOmitList,
} from '@/components/ConfigurableColumns';
import { useMemo } from 'react';
import { DefaultPagination } from '@/components/DefaultPagination';
import { AppTrackerCommandPanel } from './DataExportsCommandPannel';
import { CreateDataExportButton } from './CreateDataExportButton';
import { createDateFilters } from '@/util/DateFilters';

export const listFilters = [
  <SelectArrayInput
    key="collectionName"
    label="Entity"
    source="collectionName"
    alwaysOn
    choices={[
      { id: 'therapists', name: 'Therapists' },
      { id: 'therapistSessionNotes', name: 'Session Notes' },
      { id: 'appTrackerEvents', name: 'App Tracker Events' },
    ]}
  />,
  ...createDateFilters('createdAt', 'Created'),
];

const ListActions = () => (
  <TopToolbar>
    <CreateDataExportButton />
    <FilterButton />
    <SelectColumnsButton />
  </TopToolbar>
);

export const DataExportsList = () => {
  const omitList = useMemo(() => renderOmitList(columns), []);

  const gridColumns = useMemo(() => renderGridColumns(columns), []);

  const sort = useMemo(
    () => ({ field: 'createdAt', order: 'DESC' as const }),
    [],
  );

  return (
    <List
      resource="dataExports"
      perPage={25}
      filters={listFilters}
      actions={<ListActions />}
      sort={sort}
      queryOptions={{
        meta: {
          facet: false,
        },
      }}
      pagination={<DefaultPagination />}
    >
      <DatagridConfigurable
        bulkActionButtons={false}
        expand={AppTrackerCommandPanel}
        // expand={null}
        omit={omitList}
      >
        {gridColumns}
      </DatagridConfigurable>
    </List>
  );
};

const documentsCsvExporter = genericCSVExporter(
  'appTrackerEvents',
  renderExportColumns(columns),
);
